<template>
  <div class="">
    <top-header :type="3" :isShow="false" :bgColor="bgColor" :textColor="textColor" />
    <div class="top_banner" ref="topBanner">
      <swiper class="swiper" :options="swiperOptionh" ref="mySwiper">
        <swiper-slide v-for="(item, index) in imgList" :key="index">
          <img @click="showModel" :src="imgPath + 'sClf/' + item.fileId + '.jpg'" alt="" />
        </swiper-slide>
        <swiper-slide v-if="!imgList.length">
          <img src="@/assets/img/default_house_list.jpg" alt="" />
        </swiper-slide>
      </swiper>
      <div class="total">共{{ imgList.length }}张</div>
      <div class="pagination m_flex_box flex_vc flex_hc">
        <span :class="topSwiperIndex === 1 ? 'active' : ''" @click="toSlide(1)">图片</span>
      </div>
    </div>
    <div class="top_info" v-if="detail && detail.currentListed">
      <div class="m_flex_box flex_jz flex_vc">
        <h3>
          {{
          detail.currentListed.tgmc
          ? detail.currentListed.tgmc
          : detail.currentListed.xmmc
          }}
        </h3>
        <p>
          {{
          detail.currentListed.unitPrice
          ? detail.currentListed.unitPrice + "元/m²"
          : "暂无"
          }}
        </p>
      </div>
      <div class="m_flex_box flex_vc flex_jz">
        <div class="icon m_flex_box flex_vc">
          <span>在售</span>
          <!-- 写死接口没有返回 -->
          <p v-for="(item, index) in detail.listLabel" :key="index">
            <i>{{ item.param1 }}</i>
          </p>
        </div>
        <p style="margin-top: 0.3rem">
          {{
          detail
          ? detail.currentListed.businessId
          ? "商业网站挂牌"
          : detail.currentListed.listedType === 0
          ? "个人核验挂牌"
          : "经纪人核验挂牌"
          : "-"
          }}
        </p>
      </div>
      <div class="three_info m_flex_box flex_vc flex_jz">
        <div class="inner">
          <h5 class="inner_tit">
            {{
            detail.currentListed.listedPrice
            ? parseFloat((detail.currentListed.listedPrice / 10000).toFixed(2)) + "万"
            : "暂无"
            }}
          </h5>
          <p>总价</p>
        </div>
        <div class="inner">
          <h5 class="inner_tit">
            {{
            detail.currentListed.room ? detail.currentListed.room : "-"
            }}室{{
            detail.currentListed.hall ? detail.currentListed.hall : "-"
            }}厅{{
            detail.currentListed.toilet ? detail.currentListed.toilet : "-"
            }}卫
          </h5>
          <p>户型</p>
        </div>
        <div class="inner">
          <h5 class="inner_tit">
            {{
            detail.currentListed.zmjCount
            ? detail.currentListed.zmjCount + "m²"
            : "暂无"
            }}
          </h5>
          <p>面积</p>
        </div>
      </div>
      <div class="test_code m_flex_box flex_vc flex_jz">
        <div class="m_flex_box flex_vc left">
          <img src="@/assets/img/dun.png" alt="" />
          <div>
            <h5>房源核验统一编码：</h5>
            <p>
              {{
              detail.houseMain.uniqueCode
              ? detail.houseMain.uniqueCode
              : "暂无"
              }}
            </p>
          </div>
        </div>
        <p class="btn" @click="toCheck">房源核验</p>
      </div>
    </div>
    <div class="bor_b">
      <div class="main_inner">
        <div class="m_flex_box flex_vc flex_jz tit_con">
          <h3 class="inner_tit">基本信息</h3>
          <router-link :to="{
            path: '/oldProjectDetail',
            query: { mainId: mainId, houseListedId: houseListedId },
          }" class="arrow m_flex_box flex_vc">
            <span>查看全部</span>
            <van-icon name="arrow" />
          </router-link>
        </div>
        <div class="info_con" v-if="detail && detail.currentListed">
          <div class="row">
            <p>
              <span>备案名称</span>{{ detail.currentListed.xmmc ? detail.currentListed.xmmc : "-" }}
            </p>
          </div>
          <div class="row m_flex_box">
            <p class="flex-1">
              <span>房屋单价</span>{{
              detail.currentListed.unitPrice
              ? detail.currentListed.unitPrice + "元/m²"
              : "暂无"
              }}
            </p>
            <p class="flex-1">
              <span>所属区域</span>{{ areaName ? areaName : "-" }}
            </p>
          </div>
          <div class="row m_flex_box">
            <p class="flex-1">
              <span>建成年代</span>{{
              detail.currentListed.completionDate
              ? detail.currentListed.completionDate
              : "-"
              }}
            </p>
            <p class="flex-1">
              <span>有无暖气</span>{{ detail.currentListed.heating == 1 ? "有" : "无" }}
            </p>
          </div>
          <div class="row m_flex_box">
            <p class="flex-1">
              <span>配备电梯</span>{{ detail.currentListed.elevator == 1 ? "有" : "无" }}
            </p>
            <p class="flex-1">
              <span>所在楼层</span>{{
              detail.currentListed.layerCn
              ? detail.currentListed.layerCn
              : "-"
              }}
            </p>
          </div>
          <div class="row m_flex_box">
            <p class="flex-1">
              <span>房屋户型</span>{{
              detail.currentListed.room ? detail.currentListed.room : "-"
              }}室{{
              detail.currentListed.hall ? detail.currentListed.hall : "-"
              }}厅{{
              detail.currentListed.toilet ? detail.currentListed.toilet : "-"
              }}卫
            </p>
            <p class="flex-1">
              <span>梯户比例</span>{{
              detail.currentListed.ladder ? detail.currentListed.ladder : "-"
              }}梯{{
              detail.currentListed.households
              ? detail.currentListed.households
              : "-"
              }}户
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="bor_b" v-if="detail">
      <div class="main_inner">
        <div class="m_flex_box flex_vc flex_jz tit_con">
          <h3 class="inner_tit">设备设施</h3>
        </div>
        <div class="device_con m_flex_box flex_vc flex_vw">
          <div :class="array2.includes('0') ? '' : 'none'">
            <img src="@/assets/img/old/f0.png" alt="" />
            <p>床</p>
          </div>
          <div :class="array2.includes('1') ? '' : 'none'">
            <img src="@/assets/img/old/f1.png" alt="" />
            <p>沙发</p>
          </div>
          <div :class="array2.includes('2') ? '' : 'none'">
            <img src="@/assets/img/old/f2.png" alt="" />
            <p>衣柜</p>
          </div>
          <div :class="array2.includes('3') ? '' : 'none'">
            <img src="@/assets/img/old/f3.png" alt="" />
            <p>餐桌</p>
          </div>
          <div :class="array2.includes('4') ? '' : 'none'">
            <img src="@/assets/img/old/f4.png" alt="" />
            <p>茶几</p>
          </div>
          <div :class="array2.includes('5') ? '' : 'none'">
            <img src="@/assets/img/old/f5.png" alt="" />
            <p>电视机柜</p>
          </div>
          <div :class="array2.includes('6') ? '' : 'none'">
            <img src="@/assets/img/old/f6.png" alt="" />
            <p>鞋柜</p>
          </div>
          <div :class="array.includes('0') ? '' : 'none'">
            <img src="@/assets/img/old/g01.png" alt="" />
            <p>电视</p>
          </div>
          <div :class="array.includes('1') ? '' : 'none'">
            <img src="@/assets/img/old/g1.png" alt="" />
            <p>冰箱</p>
          </div>
          <div :class="array.includes('2') ? '' : 'none'">
            <img src="@/assets/img/old/g2.png" alt="" />
            <p>空调</p>
          </div>
          <div :class="array.includes('3') ? '' : 'none'">
            <img src="@/assets/img/old/g3.png" alt="" />
            <p>洗衣机</p>
          </div>
          <div :class="array.includes('4') ? '' : 'none'">
            <img src="@/assets/img/old/a4.png" alt="" />
            <p>热水器</p>
          </div>
          <div :class="array.includes('5') ? '' : 'none'">
            <img src="@/assets/img/old/g5.png" alt="" />
            <p>电脑</p>
          </div>
          <div :class="array.includes('6') ? '' : 'none'">
            <img src="@/assets/img/old/g6.png" alt="" />
            <p>燃气灶</p>
          </div>
        </div>
      </div>
    </div>
    <div class="bor_b" v-if="detail && detail.listFeature">
      <div class="main_inner">
        <div class="m_flex_box flex_vc flex_jz tit_con">
          <h3 class="inner_tit">房源特色</h3>
        </div>
        <div class="text_info" v-for="(item, index) in detail.listFeature" :key="index">
          <div class="inner">
            <h5 v-if="item.featureType == 0">核心卖点</h5>
            <h5 v-if="item.featureType == 1">户型介绍</h5>
            <h5 v-if="item.featureType == 2">小区介绍</h5>
            <h5 v-if="item.featureType == 3">交通出行</h5>
            <p v-html="item.content"></p>
          </div>
        </div>
      </div>
    </div>
    <div class="bor_b">
      <div class="main_inner">
        <div class="m_flex_box flex_vc flex_jz tit_con">
          <h3 class="inner_tit">户型信息</h3>
        </div>
        <div class="pic_info" v-if="detail && detail.currentListed">
          <div class="m_flex_box flex_jz">
            <p>
              <span>户型信息</span>{{
              detail.currentListed.zmjCount
              ? detail.currentListed.zmjCount + "㎡"
              : "-"
              }}
            </p>
            <p>
              <span>室数</span>{{ detail.currentListed.room ? detail.currentListed.room : "-" }}
            </p>
            <p>
              <span>厅数</span>{{ detail.currentListed.hall ? detail.currentListed.hall : "-" }}
            </p>
            <p>
              <span>卫数</span>{{
              detail.currentListed.toilet ? detail.currentListed.toilet : "-"
              }}
            </p>
          </div>
          <img v-show="detail.currentListed.houseMapId" v-lazy="
            imgPath + 'sImgHouse/' + detail.currentListed.houseMapId + '.jpg'
          " alt="" />
        </div>
      </div>
    </div>
    <div class="bor_b" v-if="detail && detail.itemInfo ? detail.itemInfo.zb : false">
      <div class="main_inner">
        <div class="m_flex_box flex_vc flex_jz tit_con">
          <h3 class="inner_tit">位置及周边配套</h3>
        </div>
        <div>
          该功能正在升级中
        </div>
        <div class="map_tab_con" v-if="false">
          <span :class="keyword === '公交' ? 'active' : ''" @click="changeMap('公交')">公交</span>
          <span :class="keyword === '医疗' ? 'active' : ''" @click="changeMap('医疗')">医疗</span>
          <span :class="keyword === '银行' ? 'active' : ''" @click="changeMap('银行')">银行</span>
          <span :class="keyword === '商业' ? 'active' : ''" @click="changeMap('商业')">商业</span>
          <span :class="keyword === '学校' ? 'active' : ''" @click="changeMap('学校')">学校</span>
        </div>
        <div class="map_con" v-if="false">
          <baidu-map class="bm-view" :center="center1" :scroll-wheel-zoom="true" :zoom="zoom" @ready="handler">
            <bm-local-search :keyword="keyword" location="徐州" :nearby="nearby" :panel="false" @searchcomplete="search"
              :auto-viewport="true"></bm-local-search>
            <bm-marker :position="center" :scroll-wheel-zoom="true"
              :icon="{ url: icon, size: { width: 34, height: 40 } }" :top="true" :zIndex="11"></bm-marker>
            <bm-marker v-for="(item, index) in mapList" :key="index + '*'" :position="item.point"
              :scroll-wheel-zoom="true" :icon="{ url: icon1, size: { width: 24, height: 36 } }" :offset="offset">
            </bm-marker>
            <bm-info-window :position="infoPosition" :show="show" @open="infoWindowOpen" @close="infoWindowClose">
              <div v-html="infoWindow"></div>
            </bm-info-window>
          </baidu-map>
          <div class="map_list">
            <div class="row m_flex_box flex_vc flex_jz" v-for="(item, index) in mapList" :key="index + 'key'"
              @click="setCenter(item)">
              <span>{{ index + 1 }}</span>
              <div class="right">
                <h5>{{ item.title }}</h5>
                <p>{{ item.address }}</p>
              </div>
            </div>
          </div>
          <transition name="slide-y" mode="out-in">
            <div class="no_map m_flex_box flex_vc flex_hc" v-if="(mapList && !mapList.length) || !mapList">
              暂无{{ keyword }}数据
            </div>
          </transition>
        </div>
      </div>
    </div>
    <div class="bor_b" v-if="sameSource.length > 0">
      <div class="main_inner">
        <div class="m_flex_box flex_vc flex_jz tit_con">
          <h3 class="inner_tit">同房源其他挂牌</h3>
          <router-link :to="{
            path: '/tfyRecord',
            query: { mainId: mainId, houseListedId: houseListedId },
          }" class="arrow m_flex_box flex_vc">
            <span>查看全部</span>
            <van-icon name="arrow" />
          </router-link>
        </div>
        <div class="record_list">
          <div class="row m_flex_box flex_vc flex_jz" v-for="(item, index) in sameSource" :key="index"
            @click="checkDetail(item.id)">
            <div class="left m_flex_box flex_vc" style="flex: 1; display: flex">
              <img v-lazy="imgPath + 'sClf/' + item.img + '.jpg'" alt="" />
              <div class="priceLocation">
                <h5>
                  {{
                  item.businessId
                  ? item.businessName
                  : item.createName
                  ? item.createName
                  : "-"
                  }}
                </h5>
                <p>
                  {{
                  item.businessId
                  ? " 商业网站挂牌 "
                  : item.listedType == 0
                  ? "个人核验挂牌"
                  : "经纪人核验挂牌"
                  }}
                </p>
                <span style="
                    margin-left: 0.16rem;
                    color: #f92d2d;
                    font-weight: bold;
                  ">{{ Math.round(item.listedPrice / 10000) }}万元</span>
              </div>
            </div>
            <div class="right m_flex_box" v-if="!item.businessId">
              <a @click.stop="callTo(item.phoneNum, 1, item.listedUserId)">
                <img src="@/assets/img/r_tel.png" alt="" />
              </a>
              <img src="@/assets/img/r_chat.png" alt="" @click.stop="toTalk(item.id)" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bor_b" v-if="list.list2">
      <div class="main_inner">
        <div class="m_flex_box flex_vc flex_jz tit_con">
          <h3 class="inner_tit">看房记录</h3>
          <router-link :to="{
            path: '/kfRecord',
            query: { mainId: mainId, houseListedId: houseListedId },
          }" class="arrow m_flex_box flex_vc">
            <span>查看全部</span>
            <van-icon name="arrow" />
          </router-link>
        </div>
        <div class="record_list">
          <div class="row m_flex_box flex_vc flex_jz" v-for="(item, index) in list2" :key="index">
            <div class="left m_flex_box flex_vc">
              <img v-lazy="imgPath + 'sClf/' + item.brokerImg + '.jpg'" alt="" />
              <div>
                <h5>{{ item.brokerName ? item.brokerName : "-" }}</h5>
                <p>{{ item.seeDate | formatTime("yyyy-MM-dd") }}带看过本房</p>
              </div>
            </div>
            <div class="right m_flex_box">
              <a @click.stop="callTo(item.brokerPhone, 1, item.id)">
                <img src="@/assets/img/r_tel.png" alt="" />
              </a>
              <img src="@/assets/img/r_chat.png" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bor_b" v-if="detail && detail.itemInfo ? detail.itemInfo.itemid : false">
      <div class="main_inner">
        <div class="m_flex_box flex_vc flex_jz tit_con">
          <h3 class="inner_tit">{{ detail ? detail.itemInfo.tgmc : "" }}</h3>
          <div @click="toUrl(detail.itemInfo.itemid, detail.itemInfo.old)" class="arrow m_flex_box flex_vc">
            <span>小区详情</span>
            <van-icon name="arrow" />
          </div>
        </div>
        <div class="deltail_con m_flex_box flex_vc flex_jz">
          <div class="left flex_v flex_jz">
            <div class="m_flex_box flex_vc">
              <h5>
                <span>{{
                detail
                ? detail.itemInfo.nxsjg
                ? detail.itemInfo.nxsjg
                : "暂无"
                : "暂无"
                }}</span>元/平
              </h5>
            </div>
            <p class="col_gray">在售房源：{{ detail.itemInfo.ksts }}套</p>
          </div>
          <img v-lazy="imgPath + 'sImgMin/' + detail.itemInfo.xmfm + '.jpg'" alt="" />
        </div>
      </div>
    </div>
    <div class="bor_b" v-if="list.length">
      <div class="main_inner">
        <div class="m_flex_box flex_vc flex_jz tit_con">
          <h3 class="inner_tit">同小区房源</h3>
        </div>
        <div class="list_con old_list">
          <div class="inner m_flex_box flex_vc" v-for="(item, index) in list" :key="index"
            @click="toDetail(item.id, item.mainId)">
            <div class="inner_l">
              <img class="banner" v-lazy="imgPath + 'sClf/' + item.fileId + '.jpg'" />
            </div>
            <div class="new_r">
              <div class="m_flex_box flex_vc flex_jz tit">
                <h4 class="line_comp1">{{ item.tgmc ? item.tgmc : "" }}</h4>
                <i>在售</i><!-- 接口没有返回数据 -->
              </div>
              <p class="line_comp1 col_gray">
                {{ item.xzqh ? item.xzqh : "-" }} /
                {{ item.zmjCount ? item.zmjCount + "m²" : "-" }} /
                {{ item.room ? item.room : "-" }}室{{
                item.hall ? item.hall : "-"
                }}厅
              </p>
              <div class="m_flex_box flex_jz">
                <div class="price m_flex_box flex_vb">
                  <h4>
                    {{
                    item.listedPrice ? item.listedPrice / 10000 + "万" : "-"
                    }}
                  </h4>
                  <p>{{ item.unitPrice ? item.unitPrice + "元/平" : "-" }}</p>
                </div>
                <a @click.stop="
                  callPhone_(
                    item.phoneNum == null ? '暂无' : item.phoneNum,
                    item.listedType,
                    item.listedUserId
                  )
                " class="tel"><img src="@/assets/img/tel.png" alt="" /></a>
              </div>
              <div class="num m_flex_box flex_vc">
                <img src="@/assets/img/check.png" alt="" /><span>核验编码</span>{{ item.uniqueCode ? item.uniqueCode : "暂无"
                }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="top_info" v-if="detail && !detail.currentListed.businessId">
      <div class="test_code m_flex_box flex_vc flex_jz test_bottom">
        <div class="m_flex_box flex_vc left">
          <img src="@/assets/img/icon/1.png" alt="" />
          <div>
            <h5>满意房源,意向签约：</h5>
          </div>
        </div>
        <p class="btn" @click="toSign">与我签约</p>
      </div>
    </div>
    <div class="pad_b"></div>
    <div class="footer_ m_flex_box flex_vc flex_jz" v-if="detail">
      <div class="left m_flex_box flex_vb">
        <div @click="toAgentDetail(detail.currentListed)">
          <img :src="
            detail.currentListed.img
              ? (!detail.currentListed.listedType
                  ? 'https://www.xzhouse.com.cn/house/xzh_static/sTx/'
                  : 'https://www.xzhouse.com.cn/house/xzh_static/sClf/') +
                detail.currentListed.img +
                '.jpg'
              : 'https://www.xzhouse.com.cn/house/xzh_static/sTx/tx.jpg'
          " class="tx" alt="" />
          <p>
            {{
            detail.currentListed.businessId
            ? detail.currentListed.businessName
            : detail.currentListed.createName
            ? detail.currentListed.createName
            : "-"
            }}
          </p>
        </div>
        <div @click="collectOption">
          <img class="collect" :src="isCollect ? collected : collectNo" alt="" />
          <p>{{ isCollect ? "已收藏" : "收藏" }}</p>
        </div>
      </div>
      <div class="right m_flex_box">
        <div v-if="!detail.currentListed.businessId" class="m_flex_box flex_vc flex_hc light" @click="
          toTalk(
            detail.currentListed.userId
              ? detail.currentListed.userId
              : detail.currentListed.listedUserId
          )
        ">
          <img src="@/assets/img/btn_write.png" alt="" />
          <span>与我聊天</span>
        </div>
        <div class="m_flex_box flex_vc flex_hc dark" @click="callPhone" v-if="!detail.currentListed.businessId">
          <img src="@/assets/img/btn_phone.png" alt="" />
          <span>电话咨询</span>
        </div>
        <div class="m_flex_box flex_vc flex_hc dark" style="width: 4.16rem" v-if="detail.currentListed.businessId">
          <a :href="detail.currentListed.businessUrl" class="m_flex_box_a">跳转商业网站房源</a>
        </div>
      </div>
    </div>
    <van-overlay class="flex_v flex_hc flex_vc" :show="showCover" @click="showCover = false" z-index="9">
      <div class="check_con" @click.stop>
        <div class="check_top m_flex_box flex_vc flex_hc" :class="
          cf === 1 && dy === 1
            ? 'error'
            : cf === 1 || dy === 1
            ? 'warning'
            : 'success'
        ">
          <img src="@/assets/img/yz.png" alt="" />
          <div>
            <h5>{{ msg }}</h5>
            <p>{{ uniqueCode.info }}</p>
          </div>
        </div>
        <div class="check_bottom">
          <p>{{ uniqueCode.detail }}</p>
          <div class="btn" :class="
            cf === 1 && dy === 1
              ? 'error'
              : cf === 1 || dy === 1
              ? 'warning'
              : 'success'
          " @click="closeCover">
            确定
          </div>
        </div>
      </div>
    </van-overlay>
    <div class="load_con m_flex_box flex_vc flex_hc" v-if="isLoading">
      <div class="inner m_flex_box flex_vc flex_hc">
        <van-loading />
      </div>
    </div>
  </div>
</template>

<script>
const map1 = require("@/assets/img/map/1.png");
const map2 = require("@/assets/img/map/2.png");
const map3 = require("@/assets/img/map/3.png");
const map4 = require("@/assets/img/map/4.png");
const map5 = require("@/assets/img/map/5.png");
import qs from "qs";
import { mapGetters } from "vuex";
import { ImagePreview } from "vant";
import topHeader from "@/components/header";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/swiper-bundle.css";
export default {
  name: "HouseDetail",
  data() {
    return {
      isLoading: true,
      collected: require("@/assets/img/collect_.png"),
      collectNo: require("@/assets/img/collect.png"),
      isCollect: 0,
      bgColor: "transparent",
      textColor: "#fff",
      tabIndex: 0,
      topSwiperIndex: 1,
      scale: 1,
      swiperOptionh: {
        pagination: {},
      },
      showCover: false,
      zoom: 10,
      markerList: [{ lng: 117.290313, lat: 34.209974 }],
      active: false,
      icon: require("@/assets/img/zulinxiangqing_ditu_icon.png"),
      icon1: map1,
      center: {},
      center1: {},
      position: { lat: 34.209974, lng: 117.290313, title: "" },
      options: {},
      local: null,
      keyword: "公交",
      show: false,
      infoPosition: {},
      infoWindow: "",
      nearby: {
        center: {
          lat: 34.209974,
          lng: 117.290313,
        },
        radius: 1000,
      },
      offset: { height: -16, width: 0 },
      mapList: [],
      formData: {
        area: this.main.getHostArea(),
      },
      listPage: 1,
      houseListedId: this.$route.query.houseListedId,
      mainId: this.$route.query.mainId,
      detail: null,
      list: [],
      list2: [],
      areaName: "",
      code: "",
      uniqueCode: "",
      msg: "",
      cf: "",
      dy: "",
      imgList: [],
      array2: [],
      array: [],
      itemid: "",
      timer: null,
      restrictedArea: [],
      onlineSignArea: [],
      commissionArea: [],
      sameSource: [], //同房源挂牌数的数组
    };
  },
  watch: {
    "$route.query.houseListedId": {
      handler(to, from) {
        this.checkDetail(to);
      },
    },
  },
  components: {
    topHeader,
    Swiper,
    SwiperSlide,
    [ImagePreview.Component.name]: ImagePreview.Component,
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  filters: {
    formatTime: function (dates, fmt) {
      var date = new Date(dates);
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          (date.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      }
      var o = {
        "M+": date.getMonth() + 1,
        "d+": date.getDate(),
        "h+": date.getHours(),
        "m+": date.getMinutes(),
        "s+": date.getSeconds(),
      };
      for (var k in o) {
        if (new RegExp("(" + k + ")").test(fmt)) {
          var str = o[k] + "";
          fmt = fmt.replace(
            RegExp.$1,
            RegExp.$1.length === 1 ? str : ("00" + str).substr(str.length)
          );
        }
      }
      return fmt;
    },
    format(data) {
      if (data === "320302000000") {
        return "鼓楼区";
      } else if (data === "320311000000") {
        return "泉山区";
      } else if (data === "320303000000") {
        return "云龙区";
      } else if (data === "320398000000") {
        return "金山桥";
      } else if (data === "320312000000") {
        return "铜山区";
      } else if (data === "320305000000") {
        return "贾汪区";
      } else if (data === "320399000000") {
        return "高新区";
      } else if (data === "320397000000") {
        return "港务区";
      } else if (data === "320382000000") {
        return "邳州市";
      } else if (data === "320381000000") {
        return "新沂市";
      } else if (data === "320321000000") {
        return "丰县";
      } else if (data === "320324000000") {
        return "睢宁";
      } else if (data === "320322000000") {
        return "沛县";
      } else if (data === "320") {
        return "市区";
      }
    },
  },
  provide() {
    return {
      reload: this.reload,
    };
  },
  inject: ["reload"],
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    this.getDetail();
    this.getBrokerSeeRecord();
    this.getAreaList();
  },
  methods: {
    checkDetail(id) {
      this.$router.push({
        path: "/houseDetail",
        query: {
          mainId: this.mainId,
          houseListedId: id,
        },
      });
      this.reload();
    },
    callTo(phone, lx, infoId) {
      this.$http.post("cms/onlineUser/reg/isLogin.do").then((res) => {
        if (res.success) {
          this.$new
            .post(
              "telTj/addTeltj.do",
              qs.stringify({
                phone,
                lx,
                infoId,
              })
            )
            .then((res) => {
              window.location.href = `tel:${phone}`;
            });
        } else {
          this.$toast(res.msg);
        }
      });
      // if (!phone) {
      //   this.$dialog.alert({
      //     title: "提示",
      //     message: "暂无可拨打电话",
      //   });
      //   return;
      // }
      // this.$new
      //   .post(
      //     "telTj/addTeltj.do",
      //     qs.stringify({
      //       phone,
      //       lx,
      //       infoId,
      //     })
      //   )
      //   .then((res) => {
      //     window.location.href = `tel:${phone}`;
      //   });
    },
    toTalk(id) {
      this.$router.push({
        path: "/chat",
        query: {
          id,
        },
      });
    },

    toAgentDetail(item) {
      if (!item.businessId || (item.businessId && !item.businessUrl)) {
        if (item.listedType == 1) {
          this.$router.push({
            path: "/agentDetail",
            query: {
              id: item.listedUserId,
            },
          });
        }
      }
    },
    getAreaList() {
      this.$http.post("cms/onlineUser/permit/areaList.do").then((res) => {
        this.restrictedArea = res.obj.restrictedArea;
        this.onlineSignArea = res.obj.onlineSignArea;
        this.commissionArea = res.obj.commissionArea;
      });
    },
    callPhone() {
      this.$http.post("cms/onlineUser/reg/isLogin.do").then((res) => {
        if (res.success) {
          this.$new
            .post(
              "telTj/addTeltj.do",
              qs.stringify({
                phone: this.detail.currentListed.phoneNum,
                lx: this.detail.currentListed.listedType,
                infoId: this.detail.currentListed.listedUserId,
              })
            )
            .then((res) => {
              window.location.href = `tel:${this.detail.currentListed.phoneNum}`;
            });
        } else {
          this.$toast(res.msg);
        }
      });
    },
    callPhone_(phone, lx, infoId) {
      if (!phone) {
        this.$dialog.alert({
          title: "提示",
          message: "暂无可拨打电话",
        });
        return;
      }
      this.$http.post("cms/onlineUser/reg/isLogin.do").then((res) => {
        if (res.success) {
          this.$new
            .post(
              "telTj/addTeltj.do",
              qs.stringify({
                phone,
                lx,
                infoId,
              })
            )
            .then((res) => {
              window.location.href = `tel:${phone}`;
            });
        } else {
          this.$toast(res.msg);
        }
      });
    },
    collectOption() {
      this.$http({
        url: "cms/houseCollect/reg/addHouseCollect.do",
        method: "post",
        headers: {
          "Content-Type": "application/json",
        },
        data: {
          area: this.detail.currentListed.area,
          listedId: this.houseListedId,
        },
      }).then((res) => {
        this.$toast(res.msg);
        if (res.success) {
          if (res.msg === "已为您收藏成功") {
            this.isCollect = 1;
          } else {
            this.isCollect = 0;
          }
        }
      });
    },
    getCollect() {
      this.$http({
        url: "cms/houseCollect/reg/getOldHouseCollect.do",
        method: "post",
        headers: {
          "Content-Type": "application/json",
        },
        data: {
          area: this.detail.currentListed.area,
          listedId: this.houseListedId,
        },
      }).then((res) => {
        if (res.success) {
          this.isCollect = res.obj;
        }
      });
    },
    //获取全部信息
    getDetail() {
      this.$http
        .post(
          "cms/houseListed/permit/getListedDetail.do",
          qs.stringify({
            mainId: this.mainId,
            houseListedId: this.houseListedId,
          })
        )
        .then((res) => {
          this.loading = false;
          this.isLoading = false;
          if (res.success) {
            var Img = this.logoImg;
            var url = window.location.href;
            var hosts = url.split("/#/")[0]; //获取域名加打包文件夹名称
            var shareImg = hosts.concat("/" + Img);
            this.$set(this, "sameSource", res.obj.otherListed);
            var areas = this.main.zhArea(res.obj.currentListed.area);
            this.areaName = areas;
            var huxing =
              (res.obj.currentListed.room ? res.obj.currentListed.room : "-") +
              "室" +
              (res.obj.currentListed.hall ? res.obj.currentListed.hall : "-") +
              "厅" +
              (res.obj.currentListed.toilet
                ? res.obj.currentListed.toilet
                : "-") +
              "卫";
            var dec =
              areas +
              ";" +
              huxing +
              ";" +
              (res.obj.currentListed.unitPrice
                ? res.obj.currentListed.unitPrice + "元/m²"
                : "暂无");
            this.$share(res.obj.currentListed.tgmc, dec, shareImg);
            this.code = res.obj.houseMain.uniqueCode;
            this.center = res.obj.itemInfo.zb
              ? {
                lng: res.obj.itemInfo.zb.split(",")[0],
                lat: res.obj.itemInfo.zb.split(",")[1],
              }
              : { lat: 34.209974, lng: 117.290313 };

            this.center1 = res.obj.itemInfo.zb
              ? {
                lng: res.obj.itemInfo.zb.split(",")[0],
                lat: res.obj.itemInfo.zb.split(",")[1],
              }
              : { lat: 34.209974, lng: 117.290313 };
            this.zoom = 15;
            this.$set(
              this.nearby.center,
              "lng",
              res.obj.itemInfo.zb
                ? res.obj.itemInfo.zb.split(",")[0]
                : "117.290313"
            );
            this.$set(
              this.nearby.center,
              "lat",
              res.obj.itemInfo.zb
                ? res.obj.itemInfo.zb.split(",")[1]
                : "34.209974"
            );
            this.$set(this, "detail", res.obj);
            //获取家电列表  res.obj.listAppliances     res.obj.listFurniture 家具表
            var array = [];
            var array2 = [];
            res.obj.listAppliances.forEach(function (item) {
              array.push(item.appliancesType);
            });
            this.$set(this, "array", array);
            res.obj.listFurniture.forEach(function (item) {
              array2.push(item.furnitureType);
            });
            this.$set(this, "array2", array2);
            this.$set(this, "itemid", res.obj.itemInfo.itemid);
            this.onLoad();
            this.imgList = res.obj.listImg;
            if (this.userInfo.realName) {
              this.getCollect();
            }
          }
        });
    },
    //获取看房记录
    getBrokerSeeRecord() {
      this.$http({
        url: "cms/brokerSeeRecord/permit/getBrokerSeeRecord.do",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        data: {
          pageSize: 4,
          mainId: this.mainId,
          listId: this.houseListedId,
          currPageNo: 1,
        },
      }).then((res) => {
        if (res.success) {
          this.$set(this, "list2", res.obj.rows);
          this.loading = false;
          // this.finished = true;
        }
      });
    },
    toDetail(houseListedId, mainId) {
      this.$router.push({
        path: "/houseDetail",
        query: {
          houseListedId,
          mainId,
        },
      });
      this.reload();
    },
    toUrl(itemId, old) {
      var paths = "/projectDetail";
      if (old !== "0") {
        paths = "/projectDetailIndex"; //暂时没有
      }
      this.$router.push({
        path: paths,
        query: { itemId },
      });
    },
    toSign() {
      if (this.onlineSignArea.includes(this.detail.houseMain.area)) {
        if (this.restrictedArea.includes(this.detail.houseMain.area)) {
          this.$router.push({
            path: "/signWithMe",
            query: {
              date: this.detail.fzrq,
              month: this.detail.fzrq_month,
              houseListedId: this.$route.query.houseListedId,
              flag: this.commissionArea.includes(this.detail.houseMain.area),
            },
          });
        } else {
          this.$http.post("cms/onlineUser/reg/isLogin.do").then((res) => {
            if (res.success) {
              this.$http
                .post(
                  "cms/contractData/reg/getOnlineContractDataNew.do",
                  qs.stringify({
                    houseListedId: this.$route.query.houseListedId,
                  })
                )
                .then((data) => {
                  if (data.success) {
                    this.$router.push({
                      path: "/infoCompletion",
                      query: {
                        id: data.obj,
                        flag: this.commissionArea.includes(
                          this.detail.houseMain.area
                        ),
                      },
                    });
                  } else {
                    this.$dialog
                      .alert({
                        title: "提示",
                        message: data.msg,
                      })
                      .then(() => {
                        // on close
                      });
                  }
                });
            } else {
              this.$toast(res.msg);
            }
          });
        }
      } else {
        this.$toast("该区域暂不支持线上签约");
      }
    },
    closeCover() {
      this.showCover = false;
    },
    toCheck() {
      //调用房源核验接口
      //房源核验
      this.$http
        .post(
          "cms/houseListed/permit/searchUniqueCode.do",
          qs.stringify({
            uniqueCode: this.code,
          })
        )
        .then((res) => {
          this.loading = false;
          if (res.success) {
            this.$set(this, "uniqueCode", res.obj);
            this.$set(this, "cf", res.obj.cf);
            this.$set(this, "dy", res.obj.dy);
            this.showCover = true;
          } else {
            this.$toast(res.msg);
          }
        });
    },
    showModel(parent, index) {
      this.$router.push({
        path: "/oldPhoto",
        query: {
          mainId: this.mainId,
          houseListedId: this.houseListedId,
        },
      });
    },
    handler({ BMap, map }) {
      this.map = map;
    },
    changeMap(key) {
      this.keyword = key;
      this.infoWindowClose();
      switch (key) {
        case "公交":
          this.icon1 = map1;
          break;
        case "医疗":
          this.icon1 = map2;
          break;
        case "银行":
          this.icon1 = map3;
          break;
        case "商业":
          this.icon1 = map4;
          break;
        case "学校":
          this.icon1 = map5;
          break;
        default:
          this.icon1 = map1;
      }
    },
    search(data) {
      this.$set(this, "mapList", data.Cr);
    },
    setCenter(data) {
      this.$set(this.center1, "lng", data.point.lng);
      this.$set(this.center1, "lat", data.point.lat);
      this.getPane(data);
      this.zoom = 15;
    },
    infoWindowOpen(e) {
      this.show = true;
    },
    infoWindowClose(e) {
      this.show = false;
    },
    getPane(data) {
      this.$set(this.infoPosition, "lng", data.marker.point.lng);
      this.$set(this.infoPosition, "lat", data.marker.point.lat);
      this.infoWindowOpen();
      this.infoWindow = `<div><h5>${data.title}</h5><p>${data.address}</p></div>`;
    },
    onLoad(type) {
      if (!this.timer) {
        this.timer = setTimeout(() => {
          this.timer = null;
        }, 50);
        if (!this.itemid) {
          return;
        }
        this.$http({
          url: "cms/houseListed/permit/getHouseList.do",
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          data: {
            pageSize: 20,
            offset: (this.listPage - 1) * 20,
            area: this.formData.area,
            itemId: this.itemid,
          },
        }).then((res) => {
          if (type) {
            this.isLoading = false;
          }
          if (res.success) {
            const arr = [];
            res.obj.rows.forEach((item) => {
              if (
                item.id !== this.houseListedId ||
                item.mainId !== this.mainId
              ) {
                arr.push(item);
              }
            });
            this.list = this.list.concat(arr);
            this.loading = false;
            this.listPage += 1;
          } else {
            this.finished = true;
          }
        });
      }
    },
    handleScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop > (document.documentElement.clientWidth / 7.5) * 5.6) {
        this.textColor = "#000";
        this.bgColor = "#fff";
      } else {
        this.textColor = "#fff";
        this.bgColor = "transparent";
      }
    },
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>
<style lang="less" scoped>
.load_con {
  position: fixed;
  z-index: 9999;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  color: #fff;
  font-size: 14px;

  .inner {
    background-color: rgba(0, 0, 0, 1);
    padding: 16px;
    width: 88px;
    max-width: 70%;
    min-height: 88px;
    border-radius: 8px;
  }

  p {
    margin-top: 8px;
  }
}

.top_banner {
  position: relative;
  height: 5.64rem;

  .total {
    background-color: rgba(0, 0, 0, 0.5);
    color: #fff;
    font-size: 0.24rem;
    width: 1.2rem;
    line-height: 0.5rem;
    position: absolute;
    bottom: 0.24rem;
    right: 0.4rem;
    z-index: 9;
    text-align: center;
    border-radius: 0.25rem;
  }

  img {
    height: 5.64rem;
    width: 100%;
  }

  .slide_video_con {
    position: relative;

    .cover {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 5.64rem;
      background-color: rgba(0, 0, 0, 0.3);

      i {
        color: #fff;
        font-size: 1.4rem;
      }
    }
  }
}

.pagination {
  position: absolute;
  z-index: 9;
  bottom: 0.3rem;
  left: 0;
  right: 0;

  span {
    width: 0.76rem;
    line-height: 0.36rem;
    text-align: center;
    font-size: 0.22rem;
    margin: 0 0.1rem;
    background-color: #e6e6e6;
    color: #101010;
    border-radius: 0.18rem;

    &.active {
      background-color: #3072f5;
      color: #fff;
    }
  }
}

.top_info {
  width: 7.04rem;
  margin: 0.34rem auto 0;

  h3 {
    font-size: 0.38rem;
    font-weight: 800;
    width: 70%;
  }

  .price {
    font-size: 0.26rem;
    color: #303030;
  }

  .icon {
    font-size: 0.22rem;
    margin-top: 0.3rem;

    span,
    i {
      padding: 0 0.1rem;
      line-height: 0.42rem;
      border-radius: 0.02rem;
      display: block;
    }

    span {
      background-color: #3072f5;
      color: #fff;
    }

    i {
      background-color: #ededed;
      margin-left: 0.08rem;
      color: #666;
    }
  }

  .three_info {
    margin-top: 0.38rem;

    h5 {
      font-size: 0.32rem;
      color: #f92d2d;
      font-weight: 800;
    }

    p {
      font-size: 0.24rem;
      color: #303030;
    }
  }

  .test_bottom {
    margin-bottom: 0.35rem;
    background-color: #fff0f0 !important;

    .btn {
      background-color: #ffc8c8 !important;
    }
  }

  .test_code {
    margin-top: 0.35rem;
    background-color: #e8faff;
    height: 1.22rem;
    width: 7.04rem;
    border-radius: 0.02rem;
    box-sizing: border-box;
    padding: 0 0.2rem;

    img {
      width: 0.6rem;
      margin-right: 0.16rem;
    }

    .left {
      h5 {
        font-size: 0.24rem;
        font-weight: 800;
      }

      p {
        font-weight: 800;
        font-size: 0.28rem;
        color: #17c5fb;
      }
    }

    .btn {
      font-size: 0.24rem;
      width: 1.42rem;
      line-height: 0.52rem;
      text-align: center;
      border-radius: 0.26rem;
      background-color: #17c5fb;
      color: #fff;
    }
  }
}

.main_inner {
  width: 7.04rem;
  margin: 0 auto;
  display: block;
  padding: 0.4rem 0;

  .priceLocation {
    flex: 1;
    position: relative;

    span {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }

  .tit_con {
    margin-bottom: 0.28rem;
  }

  .inner_tit {
    font-size: 0.34rem;
    font-weight: 800;
  }

  .arrow {
    color: #aaabae;
    font-size: 0.24rem;

    i {
      margin-left: 0.12rem;
    }
  }

  .text_con {
    line-height: 0.42rem;
  }
}

.info_con {
  .row {
    font-size: 0.26rem;
    margin-bottom: 0.12rem;

    &:last-child {
      margin-bottom: 0;
    }

    span {
      display: inline-block;
      color: #919191;
      margin-right: 0.12rem;
    }
  }
}

.device_con {
  padding-top: 0.2rem;

  >div {
    width: 20%;
    text-align: center;
    margin-bottom: 0.5rem;

    img {
      width: 0.48rem;
      margin-bottom: 0.1rem;
      height: 0.48rem;
      object-fit: contain;
    }

    &.none {
      -webkit-filter: grayscale(100%);
      /* Chrome, Safari, Opera */
      filter: grayscale(100%);
      opacity: 0.5;

      p {
        text-decoration: line-through;
      }
    }
  }
}

.text_info {
  margin-bottom: 0.3rem;

  .inner {
    &:last-child {
      margin-bottom: 0;
    }
  }

  h5 {
    font-size: 0.3rem;
    font-weight: 800;
    margin-bottom: 0.12rem;
  }

  p {
    color: #484848;
    font-size: 0.26rem;
  }
}

.pic_info {
  font-size: 0.26rem;

  span {
    color: #919191;
    display: inline-block;
    margin-right: 0.16rem;
  }

  img {
    border: 1px solid #f5f5f5;
    width: 4.72rem;
    height: 5.9rem;
    margin: 0.5rem auto 0;
    display: block;
  }
}

.bm-view {
  width: 100%;
  height: 3.88rem;
}

.map_tab_con {
  white-space: nowrap;
  margin-bottom: 0.3rem;
  overflow: auto;

  span {
    display: inline-block;
    font-size: 0.26rem;
    font-weight: 800;
    background-color: #f0f0f0;
    line-height: 0.56rem;
    width: 1.2rem;
    border-radius: 0.28rem;
    text-align: center;
    margin-right: 0.1rem;

    &.active {
      background-color: #e8f0ff;
      color: #2f72f5;
    }
  }
}

.map_list {
  max-height: 3rem;
  overflow: auto;

  .row {
    padding: 0.12rem 0rem;
    border-bottom: 1px solid #f4f4f4;

    span {
      font-size: 0.26rem;
      font-weight: 600;
      width: 0.46rem;
      text-align: center;
    }

    .right {
      width: 92%;

      h5 {
        font-size: 0.26rem;
        font-weight: 800;
      }

      p {
        font-size: 0.24rem;
      }
    }
  }
}

.no_map {
  font-size: 0.24rem;
  font-weight: 600;
  color: #999;
  height: 2rem;
}

/deep/ .BMap_Marker {
  img {
    width: 100%;
    object-fit: contain;
  }
}

/deep/ .BMap_pop {
  >img:nth-of-type(1) {
    display: none;
  }

  >div:not(:nth-child(9)) {
    display: none;
  }

  div:nth-child(9) {
    background-color: #2a7df9;
    box-sizing: border-box;
    height: auto !important;
    width: 3rem !important;
    left: 0.6rem !important;
    border-radius: 0.1rem;
    color: #fff;
    font-size: 0.22rem;
    padding: 0.2rem;
    box-sizing: border-box;
    overflow: visible !important;

    &:after {
      content: "";
      display: block;
      border-style: solid;
      border-width: 0.08rem;
      border-color: #2a7df9 transparent transparent transparent;
      position: absolute;
      top: 100%;
      margin-left: -0.16rem;
      left: 50%;
    }

    h5 {
      font-weight: 800;
      font-size: 0.24rem;
      margin-bottom: 0.1rem;
    }
  }
}

.record_list {
  .row {
    padding: 0.2rem 0;

    &:last-child {
      padding-bottom: 0;
    }

    .left {
      img {
        width: 0.78rem;
        height: 0.78rem;
        border-radius: 50%;
        margin-right: 0.16rem;
      }

      h5 {
        font-size: 0.28rem;
      }

      p {
        font-size: 0.22rem;
        color: #a0a0a0;
      }
    }

    .right {
      img {
        width: 0.62rem;
        height: 0.62rem;
        margin-left: 0.52rem;
      }

      a {
        img {
          margin-left: 0;
        }
      }
    }
  }
}

.deltail_con {
  .left {
    height: 1.36rem;

    h5 {
      font-size: 0.24rem;
      margin-right: 0.16rem;

      span {
        font-weight: 800;
        font-size: 0.36rem;
        margin-right: 0.08rem;
      }
    }

    >div {
      p {
        color: #a0a0a0;
        font-size: 0.22rem;
        margin-top: 0.06rem;
      }
    }

    .col_gray {
      font-size: 0.24rem;
      color: #909090;
    }
  }

  img {
    width: 1.8rem;
    height: 1.36rem;
  }
}

.list_con {
  margin: 0.05rem auto 0;
  width: 7.04rem;

  .inner {
    padding: 0.35rem 0;
    border-bottom: 1px solid #f4f4f4;
  }

  .banner {
    width: 2.44rem;
    height: 1.84rem;
  }

  .new_r {
    .tel {
      width: 0.36rem;
      height: 0.36rem;

      img {
        width: 100%;
      }
    }

    img {
      width: 100%;
    }

    width: 4.25rem;
    margin-left: 0.3rem;

    .col_gray {
      font-size: 0.24rem;
      color: #505050;
    }

    .tit {
      h4 {
        font-size: 0.36rem;
        color: #101010;
        font-weight: 800;
        width: 3rem;
      }

      i {
        //width: 0.6rem;
        padding: 0 0.04rem;
        line-height: 0.34rem;
        color: #2f72f5;
        font-size: 0.24rem;
        text-align: center;
        border: 1px solid currentColor;
        box-sizing: border-box;
        border-radius: 0.02rem;
      }

      span {
        width: 0.6rem;
        height: 0.34rem;
        text-align: center;
        line-height: 0.34rem;
        color: #fff;
        background-color: #24d064;
        font-size: 0.24rem;
        border-radius: 0.02rem;
      }
    }
  }
}

.old_list {
  .inner {
    .inner_l {
      position: relative;

      i {
        width: 0.6rem;
        height: 0.34rem;
        text-align: center;
        line-height: 0.34rem;
        color: #fff;
        background-color: #24d064;
        font-size: 0.24rem;
        position: absolute;
        display: block;
        top: 0;
      }
    }

    .new_r {
      .tit {
        margin-bottom: 0.08rem;
      }

      .col_gray {
        margin: 0.04rem 0;
      }

      .price {
        h4 {
          font-size: 0.34rem;
          color: #ff4532;
          margin-bottom: 0;
          font-weight: 800;
        }

        p {
          font-size: 0.24rem;
          color: #aaaaaa;
          margin-left: 0.12rem;
        }
      }

      .num {
        margin-top: 0.04rem;
        color: #3072f5;

        img {
          width: 0.3rem;
          height: 0.3rem;
        }

        span {
          margin: 0 0.1rem;
          color: #383333;
        }
      }
    }
  }
}

.pad_b {
  padding-bottom: 1.08rem;
}

.footer_ {
  position: fixed;
  bottom: 0;
  background-color: #fff;
  left: 0;
  right: 0;
  padding: 0.1rem 0.23rem 0.1rem 0;
  box-shadow: 0 0 0.04rem rgba(0, 0, 0, 0.3);

  .left {
    padding-left: 0.3rem;

    div {
      width: 1rem;
      text-align: center;

      .tx {
        width: 0.5rem;
        height: 0.5rem;
        border-radius: 50%;
      }

      .collect {
        width: 0.36rem;
        height: 0.36rem;
      }
    }
  }

  .right {
    .m_flex_box_a {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 100%;
      color: #fff;
    }

    >div {
      width: 2.16rem;
      height: 0.84rem;
      color: #fff;
      font-size: 0.26rem;
      font-weight: 800;
      border-radius: 0.06rem;

      img {
        width: 0.28rem;
        margin-right: 0.14rem;
      }

      &.light {
        background-color: #17c5fb;
        margin-right: 0.16rem;
      }

      &.dark {
        background-color: #2f72f5;
      }
    }
  }
}

.check_con {
  background-color: #fff;
  width: 6.64rem;
  border-radius: 0.12rem;
  overflow: hidden;

  .check_top {
    height: 2.16rem;
    color: #fff;

    img {
      width: 0.74rem;
      margin-right: 0.44rem;
    }

    h5 {
      font-size: 0.38rem;
      font-weight: 800;
      margin-bottom: 0.07rem;
    }

    p {
      font-size: 0.3rem;
    }

    &.success {
      background-color: #17c5fb;
    }

    &.warning {
      background-color: #ff9832;
    }

    &.error {
      background-color: #ee2424;
    }
  }

  .check_bottom {
    box-sizing: border-box;
    padding: 0.3rem 0.6rem;

    p {
      height: 3rem;
      overflow: auto;
      font-size: 0.28rem;
      line-height: 0.52rem;
    }
  }

  .btn {
    font-size: 0.28rem;
    text-align: center;
    color: #fff;
    line-height: 0.82rem;
    border-radius: 0.08rem;

    &.success {
      background-color: #17c5fb;
    }

    &.warning {
      background-color: #ff9832;
    }

    &.error {
      background-color: #ee2424;
    }
  }
}
</style>